var PromiseEnv = require('core/lib/promise').Promise;

var observeSelector = require('./observe_selector').observeSelector;

/**
 * Returns a promise that is resolved with the first HTMLDomElement that matches the
 * supplied selector.
 *
 * @param {string} selector
 * @returns {Promise}
 */
exports.waitForElement = function(selector:string): Promise<any> {
  return new PromiseEnv(function(resolve, reject) {
    observeSelector(selector, resolve, { once: true });
  });
};

